import { useState } from "react";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";
import { Switch } from "../../ui/switch";
import { Plus, ChevronUp, ChevronDown } from "lucide-react";

const NEEDS_SUBTITLE = new Set(["size"]);

export const AttributeManager = ({ kind, title, items, onCreate, onUpdate, onMove }) => {
  const [label, setLabel] = useState("");
  const [subtitle, setSubtitle] = useState("");

  const submit = () => {
    if (!label.trim()) return;
    onCreate(kind, label.trim(), subtitle.trim());
    setLabel("");
    setSubtitle("");
  };

  return (
    <div className="border rounded-lg p-4 space-y-3" data-testid={`album-attribute-manager-${kind}`}>
      <h4 className="font-semibold text-sm">{title}</h4>
      <div className="space-y-2">
        {items.map((item, idx) => (
          <div key={item.id} className="flex items-center gap-2" data-testid={`album-attribute-row-${item.id}`}>
            <Input
              data-testid={`album-attribute-label-${item.id}`}
              value={item.label}
              onChange={(e) => onUpdate(item.id, { label: e.target.value })}
              className="h-8 text-sm"
            />
            {NEEDS_SUBTITLE.has(kind) && (
              <Input
                data-testid={`album-attribute-subtitle-${item.id}`}
                value={item.subtitle || ""}
                placeholder="Referencia comercial"
                onChange={(e) => onUpdate(item.id, { subtitle: e.target.value })}
                className="h-8 text-sm"
              />
            )}
            <Switch
              data-testid={`album-attribute-active-${item.id}`}
              checked={item.active}
              onCheckedChange={(v) => onUpdate(item.id, { active: v })}
            />
            <button type="button" data-testid={`album-attribute-up-${item.id}`} disabled={idx === 0} onClick={() => onMove(kind, item.id, -1)} className="disabled:opacity-30">
              <ChevronUp size={14} />
            </button>
            <button type="button" data-testid={`album-attribute-down-${item.id}`} disabled={idx === items.length - 1} onClick={() => onMove(kind, item.id, 1)} className="disabled:opacity-30">
              <ChevronDown size={14} />
            </button>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-2 pt-1">
        <Input data-testid={`album-attribute-new-label-${kind}`} value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Nueva opción" className="h-8 text-sm" />
        {NEEDS_SUBTITLE.has(kind) && (
          <Input data-testid={`album-attribute-new-subtitle-${kind}`} value={subtitle} onChange={(e) => setSubtitle(e.target.value)} placeholder="Referencia comercial" className="h-8 text-sm" />
        )}
        <Button data-testid={`album-attribute-add-${kind}`} size="sm" variant="outline" onClick={submit}><Plus size={14} /></Button>
      </div>
    </div>
  );
};
